
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-358a8d04&scoped=true!stylus-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./top-tab.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./top-tab.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-358a8d04!../../node_modules/vue-loader/lib/selector?type=template&index=0!./top-tab.vue"),
  /* scopeId */
  "data-v-358a8d04",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/comps/top-tab.vue
// module id = 777
// module chunks = 34